export default "__VITE_ASSET__036e6032__"